export const siteSettings = {
  name: "Anchor Finex",
  link: "https://anchorfinex.com",
  email: "support@anchorfinex.com",
  appLink: "https://app.anchorfinex.com",
};
